import React from 'react';
import { School, User, Phone, Mail, MapPin, Calendar, Clock, Award } from 'lucide-react';
import Icon from '../../../components/AppIcon';


const TeamOverviewTab = ({ data }) => {
  const formatDate = (dateString) => {
    return new Date(dateString)?.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const InfoCard = ({ icon: Icon, label, value }) => (
    <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-lg">
      <div className="p-2 bg-blue-100 rounded-lg">
        <Icon className="w-5 h-5 text-blue-600" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm text-gray-600 mb-1">{label}</p>
        <p className="text-base font-medium text-gray-900 break-words">{value}</p>
      </div>
    </div>
  );

  return (
    <div className="space-y-6">
      {/* School Information */}
      <div>
        <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
          <School className="w-6 h-6 text-blue-600" />
          School Information
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <InfoCard icon={School} label="School Name" value={data?.schoolName} />
          <InfoCard icon={MapPin} label="Address" value={data?.schoolAddress} />
          <InfoCard icon={Phone} label="School Contact" value={data?.schoolContact} />
          <InfoCard icon={Mail} label="School Email" value={data?.schoolEmail} />
        </div>
      </div>

      {/* Point of Contact */}
      <div>
        <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
          <User className="w-6 h-6 text-blue-600" />
          Point of Contact
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <InfoCard icon={User} label="POC Name" value={data?.pocName} />
          <InfoCard icon={Phone} label="POC Phone" value={data?.pocPhone} />
          <InfoCard icon={Mail} label="POC Email" value={data?.pocEmail} />
        </div>
      </div>

      {/* Coach Details */}
      <div>
        <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
          <Award className="w-6 h-6 text-blue-600" />
          Coach Details
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <InfoCard icon={User} label="Coach Name" value={data?.coachName} />
          <InfoCard icon={Phone} label="Coach Phone" value={data?.coachPhone} />
          <InfoCard icon={Mail} label="Coach Email" value={data?.coachEmail} />
          <InfoCard icon={Award} label="Experience" value={data?.coachExperience} />
        </div>
      </div>

      {/* Registration Timeline */}
      <div>
        <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
          <Calendar className="w-6 h-6 text-blue-600" />
          Registration Timeline
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <InfoCard 
            icon={Calendar} 
            label="Submitted On" 
            value={formatDate(data?.submittedDate)} 
          />
          <InfoCard 
            icon={Clock} 
            label="Last Updated" 
            value={formatDate(data?.lastUpdated)} 
          />
        </div>
      </div>

      {/* Team Summary */}
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-6 border border-blue-100">
        <h3 className="text-xl font-bold text-gray-900 mb-4">Team Summary</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div className="text-center">
            <p className="text-3xl font-bold text-blue-600">{data?.totalPlayers}</p>
            <p className="text-sm text-gray-600 mt-1">Total Players</p>
          </div>
          <div className="text-center">
            <p className="text-3xl font-bold text-green-600">{data?.completionPercentage}%</p>
            <p className="text-sm text-gray-600 mt-1">Completion</p>
          </div>
          <div className="text-center">
            <p className="text-3xl font-bold text-indigo-600">{data?.category}</p>
            <p className="text-sm text-gray-600 mt-1">Category</p>
          </div>
          <div className="text-center">
            <p className="text-3xl font-bold text-purple-600">{data?.city}</p>
            <p className="text-sm text-gray-600 mt-1">City</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamOverviewTab;